const experience = [
  {
    company: 'ICF',
    url: 'https://icf.com',
    location: 'Remote',
    positions: [
      {
        title: 'Supervisor, Sr. UX Designer',
        startDate: 'October 2024',
        endDate: 'Present',
      },
      {
        title: 'Senior UX Designer',
        startDate: 'July 2022',
        endDate: 'October 2024',
      },
    ],
  },
  {
    company: 'SemanticBits',
    url: 'https://semanticbits.com/',
    location: 'Remote',
    positions: [
      {
        title: 'Senior UX Designer',
        startDate: 'April 2020',
        endDate: 'July 2022',
      },
      {
        title: 'UX Designer',
        startDate: 'September 2017',
        endDate: 'April 2020',
      },
    ],
  },
  {
    company: 'New York Stock Exchange',
    url: 'https://www.nyse.com/',
    location: 'New York, NY',
    positions: [
      {
        title: 'UX Designer',
        startDate: 'August 2015',
        endDate: 'March 2017',
      },
    ],
  },
  {
    company: 'Crye Precision',
    url: 'https://www.cryeprecision.com/',
    location: 'Brooklyn, NY',
    positions: [
      {
        title: 'Graphic/Web Designer',
        startDate: 'October 2013',
        endDate: 'July 2015',
      },
    ],
  },
  {
    company: 'University of Maryland, Baltimore County',
    url: 'https:/art.umbc.edu/',
    location: 'Baltimore, MD',
    positions: [
      {
        title: 'Bachelor of Arts: Graphic Design',
        endDate: 'May 2013',
      },
    ],
  },
]

export default experience
